import React from 'react';
import classnames from 'classnames';
import License from '../../../License';
import { isExtendedDeviationFullyLoaded } from '../../../DeviationPage/redux/helpers';
import MatureIndicator from '../../../SubmissionDetails/_partials/MatureIndicator';
import s from './Tier.scss';
const Tier = ({ deviation , deviation: { isMature , isNsfg , author , publishedTime , extended: { license  } = {}  } , className , contentClassName  })=>{
    const isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className, contentClassName)
    }, isExtendedLoaded && /*#__PURE__*/ React.createElement("div", {
        className: s['misc']
    }, isMature && /*#__PURE__*/ React.createElement(MatureIndicator, {
        deviation: deviation
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['license']
    }, /*#__PURE__*/ React.createElement(License, {
        license: license,
        author: author,
        publishedTime: publishedTime,
        showSymbol: false
    }))));
};
Tier.displayName = 'Tier';
export default Tier;
